import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from "svelte";
import { describeStopFailures } from "../utils/failure-message.js";
import { countdownPosition, ringDashOffset } from "../utils/countdown.js";

var root = $.from_svg(`<svg class="api-status-icon api-success svelte-161y12f" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`);
var root_1 = $.from_svg(`<svg class="api-status-icon api-error svelte-161y12f" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`);
var root_2 = $.from_svg(`<svg class="api-status-icon api-degraded svelte-161y12f" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></path></svg>`);
var root_3 = $.from_svg(`<svg class="api-status-icon api-unknown svelte-161y12f" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"></path></svg>`);
var root_4 = $.from_html(`<button class="status-floating-box-item location-button svelte-161y12f" aria-label="Update location" type="button"><svg class="location-icon svelte-161y12f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a.75.75 0 0 1 .75.75v1.81a7.45 7.45 0 0 1 6.69 6.69h1.81a.75.75 0 0 1 0 1.5h-1.81a7.45 7.45 0 0 1-6.69 6.69v1.81a.75.75 0 0 1-1.5 0v-1.81a7.45 7.45 0 0 1-6.69-6.69H2.75a.75.75 0 0 1 0-1.5h1.81a7.45 7.45 0 0 1 6.69-6.69V2.75A.75.75 0 0 1 12 2Zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"></path></svg></button>`);
var root_5 = $.from_html(`<button role="menuitem" type="button"> </button>`);
var root_6 = $.from_html(`<div class="route-selector-dropdown svelte-161y12f" role="menu" aria-label="Available routes" tabindex="-1"></div>`);
var root_7 = $.from_html(`<div class="route-selector-container svelte-161y12f"><button class="route-selector-button svelte-161y12f" aria-label="Select view/route" title="Select view/route" type="button" aria-haspopup="true"><svg class="route-selector-icon svelte-161y12f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" width="18" height="18"><path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z"></path></svg></button> <!></div>`);
var root_8 = $.from_html(`<div class="status-floating-box svelte-161y12f" role="status" aria-label="System status indicators"><div class="status-floating-box-item svelte-161y12f" id="api-status-container" role="img"><!></div> <div class="status-floating-box-item refresh-countdown svelte-161y12f" role="img"><svg viewBox="0 0 12 12" width="100%" height="100%" aria-hidden="true" class="svelte-161y12f"><circle cx="6" cy="6" r="5" class="background svelte-161y12f"></circle><circle cx="6" cy="6" r="5" class="progress svelte-161y12f" transform="rotate(-90 6 6)"></circle></svg> <span class="sr-only svelte-161y12f" id="refresh-countdown-sr">Refresh countdown timer</span></div> <!> <button class="status-floating-box-item config-button svelte-161y12f" aria-label="Open configuration" title="Open configuration" type="button"><svg class="config-icon svelte-161y12f" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.4-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"></path></svg></button> <a href="https://github.com/d-led/my-mvg-departures" target="_blank" rel="noopener noreferrer" class="status-floating-box-github status-floating-box-item svelte-161y12f" aria-label="View repository on GitHub (opens in new tab)" title="View repository on GitHub"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.46-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"></path></svg> <span class="sr-only svelte-161y12f">View repository on GitHub</span></a>  <!></div>`);

const $$css = {
	hash: 'svelte-161y12f',
	code: '.status-floating-box.svelte-161y12f {position:fixed;bottom:0.5rem;left:50%;transform:translateX(-50%);display:flex;align-items:center;gap:0.4rem;padding:0.4rem 0.6rem;background-color:rgba(128, 128, 128, 0.3);backdrop-filter:blur(4px);border-radius:0.4rem;z-index:1000;}[data-theme="light"] .status-floating-box.svelte-161y12f {background-color:rgba(128, 128, 128, 0.2);}[data-theme="dark"] .status-floating-box.svelte-161y12f {background-color:rgba(128, 128, 128, 0.4);}.status-floating-box-item.svelte-161y12f {display:flex;align-items:center;justify-content:center;width:1em;height:1em;min-width:1em;min-height:1em;flex-shrink:0;}.config-button.svelte-161y12f {background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;color:rgba(0, 0, 0, 0.8);transition:opacity 0.2s;\n    /* Override parent 1em constraint to allow larger icon */width:18px;height:18px;min-width:18px;min-height:18px;}.location-button.svelte-161y12f {background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;color:rgba(0, 0, 0, 0.8);transition:opacity 0.2s;width:18px;height:18px;min-width:18px;min-height:18px;}.location-button.svelte-161y12f:disabled {cursor:not-allowed;opacity:0.4;}[data-theme="dark"] .location-button.svelte-161y12f {color:rgba(255, 255, 255, 0.8);}.location-button.svelte-161y12f:hover:not(:disabled) {opacity:0.8;}.location-icon.svelte-161y12f {width:18px;height:18px;display:block;}[data-theme="dark"] .config-button.svelte-161y12f {color:rgba(255, 255, 255, 0.8);}.config-button.svelte-161y12f:hover {opacity:0.8;}.config-icon.svelte-161y12f {width:18px;height:18px;display:block;\n    /* Slightly larger (18px vs 16px) to account for whitespace in viewBox */}.api-status-icon.svelte-161y12f {width:100%;height:100%;display:block;}.api-status-icon.api-success.svelte-161y12f {color:#059669;}.api-status-icon.api-error.svelte-161y12f {color:#dc2626;}.api-status-icon.api-unknown.svelte-161y12f {color:rgba(255, 255, 255, 0.5);}.api-status-icon.api-degraded.svelte-161y12f {color:#d97706;}.refresh-countdown.svelte-161y12f svg:where(.svelte-161y12f) {width:100%;height:100%;display:block;}.refresh-countdown.svelte-161y12f circle:where(.svelte-161y12f) {fill:none;stroke-width:2;transition:stroke-dashoffset 0.1s linear;}[data-theme="light"] .refresh-countdown.svelte-161y12f circle:where(.svelte-161y12f) {stroke:rgba(0, 0, 0, 0.3);}[data-theme="light"] .refresh-countdown.svelte-161y12f circle.progress:where(.svelte-161y12f) {stroke:rgba(0, 0, 0, 0.8);}[data-theme="dark"] .refresh-countdown.svelte-161y12f circle:where(.svelte-161y12f) {stroke:rgba(255, 255, 255, 0.3);}[data-theme="dark"] .refresh-countdown.svelte-161y12f circle.progress:where(.svelte-161y12f) {stroke:rgba(255, 255, 255, 0.8);}.status-floating-box-github.svelte-161y12f {display:flex;align-items:center;justify-content:center;width:1em;height:1em;min-width:1em;min-height:1em;flex-shrink:0;text-decoration:none;transition:opacity 0.2s;}.status-floating-box-github.svelte-161y12f:hover {opacity:0.8;}.sr-only.svelte-161y12f {position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0;}.route-selector-container.svelte-161y12f {position:relative;display:flex;align-items:center;justify-content:center;width:18px !important;height:18px !important;min-width:18px !important;min-height:18px !important;flex-shrink:0;}.route-selector-button.svelte-161y12f {background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;color:rgba(0, 0, 0, 0.85);transition:opacity 0.2s;width:18px;height:18px;min-width:18px;min-height:18px;opacity:0.9;}[data-theme="dark"] .route-selector-button.svelte-161y12f {color:rgba(255, 255, 255, 0.85);}.route-selector-button.svelte-161y12f:hover {opacity:0.8;}.route-selector-button.svelte-161y12f svg:where(.svelte-161y12f) {width:100%;height:100%;display:block;}.route-selector-dropdown.svelte-161y12f {position:absolute;bottom:calc(100% + 0.5rem);right:0;background:white;border-radius:0.375rem;box-shadow:0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);min-width:150px;z-index:1000;overflow:hidden;}[data-theme="dark"] .route-selector-dropdown.svelte-161y12f {background:#1d232a;box-shadow:0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.2);}.route-selector-item.svelte-161y12f {display:block;width:100%;padding:0.5rem 0.75rem;text-align:left;background:none;border:none;cursor:pointer;color:#111827;font-size:0.875rem;transition:background-color 0.2s;}[data-theme="dark"] .route-selector-item.svelte-161y12f {color:#f9fafb;}.route-selector-item.svelte-161y12f:hover {background-color:rgba(0, 0, 0, 0.05);}[data-theme="dark"] .route-selector-item.svelte-161y12f:hover {background-color:rgba(255, 255, 255, 0.1);}.route-selector-item.active.svelte-161y12f {background-color:rgba(8, 123, 196, 0.1);font-weight:600;}[data-theme="dark"] .route-selector-item.active.svelte-161y12f {background-color:rgba(8, 123, 196, 0.2);}'
};

export default function StatusBar($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	let stopFailures = $.prop($$props, 'stopFailures', 19, () => []),
		routes = $.prop($$props, 'routes', 19, () => []),
		currentRoutePath = $.prop($$props, 'currentRoutePath', 3, null),
		onRouteChange = $.prop($$props, 'onRouteChange', 3, () => {}),
		refreshIntervalSeconds = $.prop($$props, 'refreshIntervalSeconds', 3, 20),
		isFetching = $.prop($$props, 'isFetching', 3, false),
		showLocationUpdate = $.prop($$props, 'showLocationUpdate', 3, false),
		onLocationUpdateClick = $.prop($$props, 'onLocationUpdateClick', 3, () => {}),
		locationUpdateDisabled = $.prop($$props, 'locationUpdateDisabled', 3, false);

	let apiStatusDetail = $.derived(() => describeStopFailures(stopFailures()));

	let apiStatusLabel = $.derived(() => $.get(apiStatusDetail)
		? `API status: ${$$props.apiStatus}. ${$.get(apiStatusDetail)}`
		: `API status: ${$$props.apiStatus}`);

	let apiStatusTitle = $.derived(() => $.get(apiStatusDetail)
		? `${$.get(apiStatusDetail)}. Retrying on every refresh.`
		: "MVG API connection status");

	let showRouteSelector = $.state(false);

	/** Wall-clock start of the current pause; the ring is derived from it, not from tick counts. */
	let countdownStartedAt = 0;

	let countdownInterval = null;
	let countdownCircle = null;
	const radius = 5;
	const circumference = 2 * Math.PI * radius;

	function toggleRouteSelector() {
		$.set(showRouteSelector, !$.get(showRouteSelector));
	}

	function selectRoute(path) {
		onRouteChange()(path);
		$.set(showRouteSelector, false);
	}

	function startCountdown() {
		stopCountdown();

		// Find the countdown circle
		const circleEl = document.querySelector(".refresh-countdown circle.progress");

		if (!circleEl) {
			// Retry after a short delay if element not found
			setTimeout(startCountdown, 100);

			return;
		}

		countdownCircle = circleEl;

		// Set up the circle
		circleEl.setAttribute("stroke-dasharray", circumference.toString());

		countdownStartedAt = Date.now();
		paintCountdown();
		countdownInterval = window.setInterval(paintCountdown, 100);
	}

	function stopCountdown() {
		if (countdownInterval !== null) {
			clearInterval(countdownInterval);
			countdownInterval = null;
		}
	}

	/**
	 * Draws the ring from the elapsed wall-clock time. Anything that throttles
	 * timers (a backgrounded tab, the embedded browser while it is not focused)
	 * then only makes the ring update less often - it never lags behind or stops.
	 * The ring starts empty and fills up as the next refresh approaches, the same
	 * direction the deployed build draws it in.
	 */
	function paintCountdown() {
		if (!countdownCircle) return;

		const { remainingFraction, remainingSeconds } = countdownPosition(countdownStartedAt, Date.now(), refreshIntervalSeconds() * 1000);

		countdownCircle.setAttribute("stroke-dashoffset", ringDashOffset(remainingFraction, circumference).toString());

		announceCountdown(remainingSeconds > 0
			? `Refresh countdown: ${remainingSeconds} seconds remaining`
			: "Refresh countdown: updating");
	}

	/** A refresh is running: the ring shows that the pause is used up. */
	function markRefreshDue() {
		stopCountdown();
		countdownCircle?.setAttribute("stroke-dashoffset", ringDashOffset(0, circumference).toString());
		announceCountdown("Refresh countdown: updating");
	}

	function announceCountdown(text) {
		const srText = document.getElementById("refresh-countdown-sr");

		if (srText && srText.textContent !== text) {
			srText.textContent = text;
		}
	}

	onDestroy(() => {
		// Clean up interval on component destroy
		if (countdownInterval !== null) {
			clearInterval(countdownInterval);
			countdownInterval = null;
		}
	});

	// One restart per finished refresh cycle: no restart on every status change
	// (too much), none missed while the cycles run (too little).
	$.user_effect(() => {
		void refreshIntervalSeconds();

		if (isFetching()) {
			markRefreshDue();

			return;
		}

		startCountdown();
	});

	var div = root_8();

	$.event('click', $.window, (e) => {
		const target = e.target;

		if ($.get(showRouteSelector) && !target.closest(".route-selector-container")) {
			$.set(showRouteSelector, false);
		}
	});

	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var svg = root();

			$.append($$anchor, svg);
		};

		var consequent_1 = ($$anchor) => {
			var svg_1 = root_1();

			$.append($$anchor, svg_1);
		};

		var consequent_2 = ($$anchor) => {
			var svg_2 = root_2();

			$.append($$anchor, svg_2);
		};

		var alternate = ($$anchor) => {
			var svg_3 = root_3();

			$.append($$anchor, svg_3);
		};

		$.if(node, ($$render) => {
			if ($$props.apiStatus === "success") $$render(consequent); else if ($$props.apiStatus === "error") $$render(consequent_1, 1); else if ($$props.apiStatus === "degraded") $$render(consequent_2, 2); else $$render(alternate, -1);
		});
	}

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_1 = $.sibling(div_2, 2);

	{
		var consequent_3 = ($$anchor) => {
			var button = root_4();

			$.template_effect(() => {
				$.set_attribute(button, 'title', locationUpdateDisabled()
					? "Switch to Next to me to update location"
					: "Update location");

				button.disabled = locationUpdateDisabled();
			});

			$.delegated('click', button, function (...$$args) {
				onLocationUpdateClick()?.apply(this, $$args);
			});

			$.append($$anchor, button);
		};

		$.if(node_1, ($$render) => {
			if (showLocationUpdate()) $$render(consequent_3);
		});
	}

	var button_1 = $.sibling(node_1, 2);
	var node_2 = $.sibling(button_1, 4);

	{
		var consequent_5 = ($$anchor) => {
			var div_3 = root_7();
			var button_2 = $.child(div_3);
			var node_3 = $.sibling(button_2, 2);

			{
				var consequent_4 = ($$anchor) => {
					var div_4 = root_6();

					$.each(div_4, 21, routes, (route) => route.path, ($$anchor, route) => {
						var button_3 = root_5();
						var text_1 = $.only_child(button_3, true);

						$.template_effect(() => {
							$.set_class(button_3, 1, `route-selector-item ${currentRoutePath() === $.get(route).path ? 'active' : ''}`, 'svelte-161y12f');
							$.set_text(text_1, $.get(route).display?.title || $.get(route).path || "Default");
						});

						$.delegated('click', button_3, () => selectRoute($.get(route).path));
						$.append($$anchor, button_3);
					});

					$.reset(div_4);
					$.append($$anchor, div_4);
				};

				$.if(node_3, ($$render) => {
					if ($.get(showRouteSelector)) $$render(consequent_4);
				});
			}

			$.reset(div_3);
			$.template_effect(() => $.set_attribute(button_2, 'aria-expanded', $.get(showRouteSelector)));

			$.delegated('click', button_2, (e) => {
				e.stopPropagation();
				toggleRouteSelector();
			});

			$.append($$anchor, div_3);
		};

		$.if(node_2, ($$render) => {
			if (routes().length > 1) $$render(consequent_5);
		});
	}

	$.reset(div);

	$.template_effect(() => {
		$.set_attribute(div_1, 'aria-label', $.get(apiStatusLabel));
		$.set_attribute(div_1, 'title', $.get(apiStatusTitle));

		$.set_attribute(div_2, 'aria-label', isFetching()
			? "Refreshing departures now"
			: "Refresh countdown timer");

		$.set_attribute(div_2, 'title', isFetching() ? "Refreshing now…" : "Time until next data refresh");
	});

	$.delegated('click', button_1, function (...$$args) {
		$$props.onConfigClick?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);